// resolve-landing.ts · Enrutado post-login por entitlement (Robotea Auto).
// ---------------------------------------------------------------------------
// GARANTÍA DE RETROCOMPATIBILIDAD: mientras nadie tenga el entitlement
// 'robotea-auto', TODOS los usuarios aterrizan en /dashboard exactamente igual
// que hoy. La única bifurcación nueva es: usuario que SOLO tiene 'robotea-auto'
// (ningún slug de curso) → /auto. Cualquier otro caso → /dashboard.
//
// Owner: Carlos Beltrán · 2026-07-08 · F-CAMPUS-AUTO-ACCESS-001

import { hasAuto } from './auto-access';

/**
 * Slugs de curso del campus (Start/Basic/Pro/Elite). Un usuario que tenga
 * CUALQUIERA de estos se considera alumno del campus → landing /dashboard.
 * Confirmados contra el código (tier-colors.ts, achievements.ts, UpsellCard.tsx).
 */
export const COURSE_SLUGS = [
  'robotea-start',
  'robotea-basic',
  'robotea-pro',
  'robotea-elite',
  'roboteam', // RoboTeam es membresía de campus (no Auto); tenerla cuenta como "tiene curso" → /dashboard
] as const;

/**
 * Decide dónde aterriza el usuario tras el login.
 *
 * - No autenticado → '/login'.
 * - Autenticado con SOLO 'robotea-auto' (ningún slug de curso) → '/auto'.
 * - Cualquier otro caso (alumno de curso, curso+auto, o sin nada) → '/dashboard'.
 *
 * Fail-safe hacia /dashboard: es el comportamiento histórico. La bifurcación a
 * /auto solo ocurre con el entitlement presente Y sin ningún curso.
 */
export function resolveLanding(opts: {
  authenticated: boolean;
  enrolledSlugs: string[];
  courseSlugs: readonly string[];
}): '/login' | '/auto' | '/dashboard' {
  if (!opts.authenticated) return '/login';
  const set = new Set(opts.enrolledSlugs);
  const hasCourse = opts.courseSlugs.some((c) => set.has(c));
  if (hasAuto(set) && !hasCourse) return '/auto';
  return '/dashboard';
}
